import { NgFor, NgIf } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MdbModalRef, MdbModalService, MdbSelectModule } from 'src/lib/mdb5-adapted/public-api';
import { MdbRippleModule } from 'src/lib/mdb5-adapted/public-api';
import { map, Observable } from 'rxjs';
import { AppUtilityService } from 'src/app/app-utility.service';
import { AreaModel, RegionModel } from 'src/app/core/models/region.model';

import { BranchService } from '@lmsrestServices';
import { LMS_NoSpecialsDirective, LmsModalFrameComponent, UpperCaseInputDirective } from '@lmsSharedUI';

import { AreaAddComponent } from '../area-add/area-add.component';
import { AreaAdminDialogComponent } from '../area-admin-dialog/area-admin-dialog.component';

@Component({
  selector: 'app-region-admin-dialog',
  templateUrl: './region-admin-dialog.component.html',
  styleUrls: ['./region-admin-dialog.component.scss'],
  standalone: true,
  imports: [
    LmsModalFrameComponent,
    FormsModule,
    LMS_NoSpecialsDirective,
    UpperCaseInputDirective,
    ReactiveFormsModule,
    NgFor,
    MdbRippleModule,
    NgIf,
    MdbSelectModule,
  ],
})
export class RegionAdminDialogComponent implements OnInit, AfterViewInit {
  regionForm = this.fb.group({
    name: '',
    id: 0,
    regionNumber: '',
    areas: this.fb.array([]),
    selArea: {},
  });

  submitted: boolean = false;
  regionModel: RegionModel;
  regionNumber: any;
  region_Ar: any;

  isEditing = false;
  enableEditIndex: number;
  editAreaIndex: number;
  regionAreaSel: any[];
  regionAreaSel$: Observable<AreaModel[]>;
  areaSelected: AreaModel = {} as AreaModel;
  isAreaEditing = false;
  private _regionSel: RegionModel;

  constructor(
    public dialogRef: MdbModalRef<RegionAdminDialogComponent>,
    private fb: FormBuilder,
    private branchService: BranchService,
    private global_utility: AppUtilityService,
    private modalService: MdbModalService
  ) {
    this.regionAreaSel$ = this.branchService.getAllAreas().pipe(
      // Map the array to filter out existing areas
      map((areas) => areas.filter((area) => !this._regionSel?.areas.map((ra) => ra.id).includes(area.id)))
    );
  }

  ngAfterViewInit(): void {
    this.regionForm.setValue({ ...this._regionSel, selArea: this.areaSelected });

    if (this.regionModel?.areas.length ?? 0 > 0) {
      this.regionForm?.controls?.areas.setValue(this.regionModel?.areas);
    }
  }

  ngOnInit() {
    this._regionSel = this.region_Ar;
    this.submitted = true;
  }

  saveRegion() {
    if (!this.regionForm.valid) {
      return;
    }

    /*** NOT AI Generated - Embarrasing ****
      this.regionModel = this.regionForm.value as RegionModel;
      this.regionModel.areas = this.region_Ar.areas;

      const selAre = this.selArea.value as AreaModel;
      if (selAre.id && selAre.name) {
        const newselArea = this.selArea.value as AreaModel;
        this.regionModel.areas.push({ id: newselArea.id, name: newselArea.name });
      }
    ***/

    /*** AI Generated - NICE ****/
    // Map form values to the region model
    this.regionModel = {
      ...this.regionForm.value,
      areas: [...this.region_Ar.areas],
    } as RegionModel;

    // Add selected area to the region model if valid
    const selectedArea = this.selArea.value as AreaModel;
    if (selectedArea?.id && selectedArea?.name) {
      this.regionModel.areas = [...this.regionModel.areas, { id: selectedArea.id, name: selectedArea.name }];
    }

    this.dialogRef.close(this.regionModel);
  }

  selectAreaEdit(areaRec?: AreaModel | null) {
    if (!areaRec) return;

    const areaSel = areaRec;
    const idx = this.region_Ar.areas.indexOf(areaRec);

    this.isAreaEditing = true;
    this.modalService
      .open(AreaAdminDialogComponent, {
        modalClass: 'modal-md modal-dialog-centered',
        containerClass: 'd-flex d-flex-md',
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: true,
        data: {
          areaRec: areaSel,
        },
      })
      .onClose.subscribe((new_areaval) => {
        if (new_areaval) {
          areaSel.name = new_areaval;
          areaSel.region = this.region_Ar;
          this.region_Ar.areas[idx] = { id: areaSel.id, name: new_areaval };
          //Save to DB
          this.branchService.saveRegion(this.region_Ar).subscribe((res) => {
            if (!res) {
              this.global_utility.error('Update region failed.', 'Add branch failed!');
            }
            this.region_Ar.areas = res.areas;
            // this.loadingService.stopLoading();
          });
        }

        this.isAreaEditing = false;
      });
  }

  findAllAreas() {
    this.regionAreaSel$.subscribe({
      next: (res) => {
        if (!res) {
          this.global_utility.error('Add new branch failed.', 'Add branch failed!');
          return;
        }
        this.regionAreaSel = res;
      },
      error: (error) => {
        console.error('Error fetching areas:', error);
        this.global_utility.error('Failed to fetch areas', 'Error');
      },
    });
  }

  createNewArea() {
    this.modalService
      .open(AreaAddComponent, {
        modalClass: 'modal-md modal-dialog-centered',
        containerClass: 'd-flex d-flex-md',
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: true,
        data: {
          areaRec: new AreaModel(),
          region: this._regionSel,
          // regionNo : lstSize
        },
      })
      .onClose.subscribe((new_area) => {
        if (new_area) {
         //SAve to DB
          this.branchService.saveArea(new_area).subscribe((res) => {
            if (!res) {
              this.global_utility.error('Add new branch failed.', 'Add branch failed!');
            }
            this._regionSel.areas = res;
            // this.loadingService.stopLoading();
          });
        } else {
          console.log('why');
        }
      });
  }

  get areas() {
    return (this.regionForm?.controls.areas as FormArray)?.controls;
  }

  get selArea() {
    return this.regionForm.controls.selArea;
  }

  close() {
    this.dialogRef.close();
  }
}
